import React from 'react';

const Header = ({ title, isBack = true }) => {
  const postMessage = () => {
    ReactNativeWebView.postMessage('closeWebView');
  };

  return (
    <section className="back_subheader">
      <button type="button" className={`btn_back ${!isBack ? 'none' : ''}`} onClick={postMessage}></button>
      <h1 className="fs-20 fw-b font-black align-c">{title}</h1>
    </section>
  );
};

export default Header;
